import { ChevronRight } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import { showFullDescription } from "ds/components/FullDescriptionDrawer";
import TextHighlight from "ds/components/TextHighlight";

import styles from "./styles.module.css";

type ModuleVersionInputsCodePreviewProps = {
  code: string;
  title: string;
};

const toMarkdownCodeBlock = (code: string) => {
  const longestBacktickRun = Math.max(0, ...(code.match(/`+/g) ?? []).map((run) => run.length));
  const fence = "`".repeat(Math.max(3, longestBacktickRun + 1));

  return `${fence}\n${code}\n${fence}`;
};

const ModuleVersionInputsCodePreview = ({ code, title }: ModuleVersionInputsCodePreviewProps) => {
  const isMultiline = code.includes("\n");

  const handleShowFullCode = () => {
    showFullDescription({ description: toMarkdownCodeBlock(code), title });
  };

  return (
    <Box align="center" gap="small" fullWidth>
      <TextHighlight className={styles.preview}>{code.replace(/\s+/g, " ")}</TextHighlight>
      {isMultiline && (
        <ButtonIcon variant="ghost" icon={ChevronRight} onPress={handleShowFullCode}>
          {`Show full ${title}`}
        </ButtonIcon>
      )}
    </Box>
  );
};

export default ModuleVersionInputsCodePreview;
